module.exports = __webpack_public_path__ + "static/media/1-6-4.4959bde3.png";